import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService } from '../../../../../services';
import { DataService } from '../../../../../services/data.service';
import { MeasurementService } from '../../../../../services/measurement.service';
import { FlangeFacingDimensionsByFlangeFacingTypeModel } from '../../../models';
import { ControlData } from '../../../models/control-data';
import { DiagramDimensionValidationModel } from '../../../models/diagram-dimension-validation-model';
import { DiagramInfo } from '../../../models/diagram-info';
import { DiagramMappings } from '../../../models/diagram-mappings';
import { Router } from '@angular/router';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-diagram-flange-facing-overrides',
    templateUrl: './diagram-flange-facing-overrides.component.html',
    styleUrls: ['./diagram-flange-facing-overrides.component.scss'],
})
export class DiagramFlangeFacingOverridesComponent implements OnInit {
    @Input()
    set diagramInfo(value: DiagramInfo) {
        this._diagramInfo = value;
        this.loadDiagramData();
    }
    get diagramInfo(): DiagramInfo {
        return this._diagramInfo;
    }

    @Input()
    set isEditable(value: boolean) {
        this._isEditable = value;
        // if (value) this.setFormValues();
    }
    get isEditable(): boolean {
        return this._isEditable;
    }
    @Input() isRedirect: boolean;
    @Input() calculationType: CalculationType;
    @Output() ringNumber: EventEmitter<string> = new EventEmitter();
    @Output() CalcOverrides: EventEmitter<ControlData> = new EventEmitter();
    @Output() DiagramFormData: EventEmitter<any> = new EventEmitter();
    destroy$ = new Subject();

    loading: boolean = false;
    diagramDimensions: DiagramDimensionValidationModel[];
    flangeFacingDimensionsByFlangeFacingType: FlangeFacingDimensionsByFlangeFacingTypeModel;
    diagramMappings: Map<string, DiagramMappings>;
    FlangeFacingDiagramFormGroup: UntypedFormGroup;
    grooveDepthDefault: string = '0.00 mm';
    outerRFODDefault: string = '0.00 mm';
    pitchDiameterDefault: string = '0.00 mm';
    reducedAreaBoltingDefault: string = '0.00 mm';
    rFDepthDefault: string = '0.00 mm';
    rFIDDefault: string = '0.00 mm';
    rFODDefault: string = '0.00 mm';
    rFThicknessDefault: string = '0.00 mm';
    private _diagramInfo: DiagramInfo;
    private _isEditable: boolean;

    constructor(
        private fb: UntypedFormBuilder,
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private dataSvc: DataService,
        private user_utility: UserUtilityService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.loadDefaultValues();

        this.FlangeFacingDiagramFormGroup = this.fb.group({
            grooveDepth: [this.grooveDepthDefault, { updateOn: 'blur' }],
            outerRFOD: [this.outerRFODDefault, { updateOn: 'blur' }],
            pitchDiameter: [this.pitchDiameterDefault, { updateOn: 'blur' }],
            reducedAreaBolting: [this.reducedAreaBoltingDefault, { updateOn: 'blur' }],
            rFDepth: [this.rFDepthDefault, { updateOn: 'blur' }],
            rFID: [this.rFIDDefault, { updateOn: 'blur' }],
            rFOD: [this.rFODDefault, { updateOn: 'blur' }],
            rFThickness: [this.rFThicknessDefault, { updateOn: 'blur' }],
        });

        this.FlangeFacingDiagramFormGroup.get('grooveDepth')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('grooveDepth', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('outerRFOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('outerRFOD', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('pitchDiameter')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('pitchDiameter', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('rFDepth')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('rFDepth', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('rFID')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('rFID', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('rFOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('rFOD', value);
                }
            });
        this.FlangeFacingDiagramFormGroup.get('rFThickness')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('rFThickness', value);
                }
            });
    }

    initialize() {
        this.FlangeFacingDiagramFormGroup.get('grooveDepth').setValue(this.grooveDepthDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('outerRFOD').setValue(this.outerRFODDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('pitchDiameter').setValue(this.pitchDiameterDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('rFDepth').setValue(this.rFDepthDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('rFID').setValue(this.rFIDDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('rFOD').setValue(this.rFODDefault, { emitEvent: false });
        this.FlangeFacingDiagramFormGroup.get('rFThickness').setValue(this.rFThicknessDefault, { emitEvent: false });
    }

    loadDefaultValues() {
        if (this.isRedirect && this.dataSvc.calculationData != null && this.dataSvc.calculationData.input.dimensionOverrides !== null) {
            if (this.dataSvc.calculationData.input.calculationType == CalculationType.OverriddenFlange) {
                this.isEditable = true;
                // this.setFormValues();
            }
            this.grooveDepthDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.grooveDepth ?? '0.00 mm';
            this.outerRFODDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.outerRFOD ?? '0.00 mm';
            this.pitchDiameterDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.pitchDiameter ?? '0.00 mm';
            this.reducedAreaBoltingDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.reducedAreaBolting ?? '0.00 mm';
            this.rFDepthDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.rFDepth ?? '0.00 mm';
            this.rFIDDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.rFID ?? '0.00 mm';
            this.rFODDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.rFOD ?? '0.00 mm';
            this.rFThicknessDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.rFThickness ?? '0.00 mm';
        }
    }

    async loadDiagramData() {
        if (this.diagramInfo.diagramId === null || this.diagramInfo.diagramId === undefined) {
            this.diagramDimensions = [];
        } else {
            await this.getDiagramDimensions();
            await this.getFlangeFacingDimensionsByFlangeFacingType();
            if (this.isEditable) this.setFormValues();
        }
    }

    async getDiagramDimensions() {
        if (this.diagramInfo != undefined) {
            await this.iceapi
                .getDiagramDimensionValidations(this.diagramInfo.diagramId, 'FlangeFacing')
                .toPromise()
                .then((res) => {
                    if (res.success) {
                        this.diagramDimensions = res.response;
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });

            if (this.diagramDimensions !== null) {
                if (this.calculationType == CalculationType.CustomFlange) {
                    this.initialize();
                }
                this.loadDiagramMappings();
                Object.keys(this.FlangeFacingDiagramFormGroup.controls).forEach((controlName) => {
                    const control = this.FlangeFacingDiagramFormGroup.get(controlName);

                    // You can now use controlName and control (which is a FormControl)
                    let match = this.diagramDimensions.findIndex((x) => x.key == controlName);
                    if (match <= -1) {
                        control.setValue(null);
                    }
                });
                this.DiagramFormData.emit(this.FlangeFacingDiagramFormGroup);
                if (this.isEditable) {
                    this.setValidations();
                }
            } else if (this.diagramDimensions === null || this.diagramDimensions.length === 0) {
                this.CalcOverrides.emit({ controlName: null, controlValue: null, isFormValid: this.FlangeFacingDiagramFormGroup.valid });
            }
        }
    }

    async getFlangeFacingDimensionsByFlangeFacingType() {
        if (this.isEditable === false && this.diagramInfo !== undefined) {
            await this.iceapi
                .getFlangeFacingDimensionsByFlangeFacingType(this.diagramInfo.flangeFacingTypeId, this.diagramInfo.pressureClassId, this.diagramInfo.pipesizeId)
                .toPromise()
                .then((res) => {
                    if (res.success) {
                        this.flangeFacingDimensionsByFlangeFacingType = res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
            if (this.flangeFacingDimensionsByFlangeFacingType != null) {
                for (var key of this.diagramMappings.keys()) {
                    let value = '0.00 mm';
                    switch (key) {
                        case 'grooveDepth':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.depth, UnitType.DefaultLengthUnit);
                            break;
                        case 'outerRFOD':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.outerRFOD, UnitType.DefaultLengthUnit);
                            break;
                        case 'pitchDiameter':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.pitchDiameter, UnitType.DefaultLengthUnit);
                            break;
                        case 'rFDepth':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfDepth, UnitType.DefaultLengthUnit);
                            break;
                        case 'rFID':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfid, UnitType.DefaultLengthUnit);
                            break;
                        case 'rFOD':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfod, UnitType.DefaultLengthUnit);
                            break;
                        case 'rFThickness':
                            value = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfThickness, UnitType.DefaultLengthUnit);
                            break;
                    }
                    this.diagramMappings.get(key).value = value;
                }
                if (this.flangeFacingDimensionsByFlangeFacingType.ringNumberId !== null) {
                    this.ringNumber.emit(this.flangeFacingDimensionsByFlangeFacingType.ringNumberId);
                }
            }
        }
    }

    setItemAndEmit(controlName: string, value: string) {
        let correctedValue = this.measSvc.format(value, UnitType.DefaultLengthUnit);
        this.FlangeFacingDiagramFormGroup.get(controlName).patchValue(correctedValue, { emitEvent: false });

        let dimension = this.diagramDimensions.find((x) => x.key == controlName);
        if (dimension) {
            if (dimension !== null && (dimension.high !== null || dimension.low !== null)) {
                if (dimension.high !== undefined && dimension.high !== null) {
                    this.FlangeFacingDiagramFormGroup.controls[dimension.high].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.high, this.FlangeFacingDiagramFormGroup.controls[dimension.high]?.value);
                }
                if (dimension.low !== undefined && dimension.low !== null) {
                    this.FlangeFacingDiagramFormGroup.controls[dimension.low].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.low, this.FlangeFacingDiagramFormGroup.controls[dimension.low]?.value);
                }
            }
        }
        this.emitOverrides(controlName, correctedValue);
        // this.setErrorsOnToolTip();
        this.setErrorMessage();
    }

    emitOverrides(controlName: string, correctedValue: string) {
        this.CalcOverrides.emit({ controlName: controlName, controlValue: correctedValue, isFormValid: this.FlangeFacingDiagramFormGroup.valid });
        this.DiagramFormData.emit(this.FlangeFacingDiagramFormGroup);
    }

    //set-up now validator message acourding to range
    setErrorMessage() {
        if (this.FlangeFacingDiagramFormGroup.invalid) {
            this.diagramDimensions.forEach((x) => {
                if (x.low && x.high) {
                    this.diagramMappings.get(x.key).toolTip =
                        'The value must be within ' +
                        this.FlangeFacingDiagramFormGroup.get(x.low).value +
                        ' - ' +
                        this.FlangeFacingDiagramFormGroup.get(x.high).value;
                } else if (x.low) {
                    this.diagramMappings.get(x.key).toolTip =
                        'The value must be equal to or greater than ' + this.FlangeFacingDiagramFormGroup.get(x.low).value;
                } else if (x.high) {
                    this.diagramMappings.get(x.key).toolTip =
                        'The value must be equal to or lesser than ' + this.FlangeFacingDiagramFormGroup.get(x.high).value;
                }
            });
        }
    }

    loadDiagramMappings() {
        this.diagramMappings = new Map<string, DiagramMappings>();
        for (var dimension of this.diagramDimensions) {
            this.diagramMappings.set(dimension.key, new DiagramMappings());
        }
    }

    setValidations() {
        this.FlangeFacingDiagramFormGroup.clearValidators();
        for (var dimension of this.diagramDimensions) {
            let controlName = dimension.key;

            if (dimension.low !== undefined && dimension.low !== null && dimension.high !== undefined && dimension.high !== null) {
                let lowCtrlName = dimension.low;
                let highCtrlName = dimension.high;

                if (this.FlangeFacingDiagramFormGroup.get(controlName)) {
                    this.FlangeFacingDiagramFormGroup.get(controlName).setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.min(this.measSvc.extractNumarical(this.FlangeFacingDiagramFormGroup.controls[lowCtrlName].value))(control),
                        (control: AbstractControl) =>
                            Validators.max(this.measSvc.extractNumarical(this.FlangeFacingDiagramFormGroup.controls[highCtrlName].value))(control),
                    ]);
                }
            } else if (dimension.low !== undefined && dimension.low !== null) {
                let lowCtrlName = dimension.low;
                this.FlangeFacingDiagramFormGroup.get(controlName).setValidators([
                    Validators.required,
                    (control: AbstractControl) =>
                        Validators.min(this.measSvc.extractNumarical(this.FlangeFacingDiagramFormGroup.controls[lowCtrlName].value))(control),
                ]);
            } else if (dimension.high !== undefined && dimension.high != null) {
                let highCtrlName = dimension.high;
                this.FlangeFacingDiagramFormGroup.get(controlName).setValidators([
                    Validators.required,
                    (control: AbstractControl) =>
                        Validators.max(this.measSvc.extractNumarical(this.FlangeFacingDiagramFormGroup.controls[highCtrlName].value))(control),
                ]);
            }
        }
        this.FlangeFacingDiagramFormGroup.updateValueAndValidity();
    }

    setFormValues() {
        if (this.router.url === '/informate/standardflange/false') {
            this.grooveDepthDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.depth, UnitType.DefaultLengthUnit);
            this.outerRFODDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.outerRFOD, UnitType.DefaultLengthUnit);
            this.pitchDiameterDefault = this.measSvc.getUserPreferedValue(
                this.flangeFacingDimensionsByFlangeFacingType.pitchDiameter,
                UnitType.DefaultLengthUnit
            );
            // this.reducedAreaBoltingDefault = this.dataSvc.calculationData.input.dimensionOverrides.reducedAreaBolting ?? '0.00 mm';
            this.rFDepthDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfDepth, UnitType.DefaultLengthUnit);
            this.rFIDDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfid, UnitType.DefaultLengthUnit);
            this.rFODDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfod, UnitType.DefaultLengthUnit);
            this.rFThicknessDefault = this.measSvc.getUserPreferedValue(this.flangeFacingDimensionsByFlangeFacingType.rfThickness, UnitType.DefaultLengthUnit);

            this.FlangeFacingDiagramFormGroup.get('grooveDepth').setValue(this.grooveDepthDefault);
            this.FlangeFacingDiagramFormGroup.get('outerRFOD').setValue(this.outerRFODDefault);
            this.FlangeFacingDiagramFormGroup.get('pitchDiameter').setValue(this.pitchDiameterDefault);
            this.FlangeFacingDiagramFormGroup.get('rFDepth').setValue(this.rFDepthDefault);
            this.FlangeFacingDiagramFormGroup.get('rFID').setValue(this.rFIDDefault);
            this.FlangeFacingDiagramFormGroup.get('rFOD').setValue(this.rFODDefault);
            this.FlangeFacingDiagramFormGroup.get('rFThickness').setValue(this.rFThicknessDefault);
            this.setValidations();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
